import { OptionsList } from './Select';
export const generateOptions = (
  options = [],
  labelKey?,
  valueKey?,
): OptionsList[] => {
  return options.map((i) => {
    return {
      label: labelKey ? i[labelKey] : i,
      value: valueKey ? i[valueKey] : i,
    };
  });
};
